export type CustomDefaults = 'custom-max-runs';

export interface CustomDefault {
  featureKey: CustomDefaults; // unique id of the feature, e.g. 'vega-panel'
  enabledFor: string; //  entity name, project name, etc
}

type CustomDefaultData = {
  [defaultKey in CustomDefaults]: {[enabledFor: string]: 0 | 1};
};

/**
 * Custom defaults are a bit of a hybrid - we enable them for individual users based on that user being a member of an allowed organization. This is a subtle difference from feature flags which are enabled per org for routes in our app that are tied to that org
 */
export const CUSTOM_DEFAULT_ORG_FLAGS: Readonly<CustomDefaultData> = {
  'custom-max-runs': {
    wandb: 0,
  },
};

export const CUSTOM_DEFAULT_USER_FLAGS: Readonly<CustomDefaultData> = {
  'custom-max-runs': {
    'cecile-parker': 1, // wandb user on the custom-max-runs project
    justintulk: 1, // wandb user on the custom-max-runs project
    dmely: 1, // this is a customer we're demoing this feature with
    nistath: 1, // this is the customer we're demoing this feature with
    sephmard: 1, // wandb user on the custom-max-runs project
    sisk: 1, // wandb user on the custom-max-runs project
  },
};
